<template>
  <div>
    <div v-if="selected === 'bifurcation'">
      <div v-if="!data.order_number">
        <EmptyState v-if="!data.order_number"
          icon="mdm"
          :text="Messages.ERR_NO_RECORDS_FOUND" />
        {{$t('INDENT_NO_DATA_FOUND')}}
      </div>
      <div class="row" v-else>
        <div class="col-md-6">
      <Header />
      <Row v-for="(d, idx) in data.materials"
        :d="d"
        :key="idx" />
        <div class="total-wrp">
      {{$t('INDENT_TOTAL')}} : {{$t('INDENT_RUPEES')}}. {{contractPrice}}
    </div>
    </div>
    <div class="col-md-6">
      <CostHeader />
      <CostRow v-for="(center, idx) in groupByCenter"
        :center="center"
        :key="idx" />
      </div>
      </div>
    </div>
    <div v-if="selected === 'calculation'">
        <EmptyState v-if="!data.order_number"
          icon="mdm"
          :text="Messages.ERR_NO_RECORDS_FOUND" />
      <FreightCalculations
        :disableFreightProvisionRetry="disableFreightProvisionRetry"
        @retry-freight-provision="$emit('retry-freight-provision')"
        v-else
        :data="data">
      </FreightCalculations>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { Movement } from 'pando-constants';
import { contractTypes } from '@/constants/order';
import Messages from '@/constants/messages';
import EmptyState from '@/components/common/EmptyState';
import Breadcrumb from '../../common/Breadcrumb';
import Header from '../../freight/MaterialFreight/Header';
import Row from '../../freight/MaterialFreight/Row';
import CostHeader from '../../freight/CostCenter/CostHeader';
import CostRow from '../../freight/CostCenter/CostRow';
import FreightCalculations from '../../freight/Calculations/FreightCalculations';
import moment from 'moment';

export default {
  components: {
    Breadcrumb,
    Header,
    Row,
    CostHeader,
    CostRow,
    EmptyState,
    FreightCalculations,
  },

  data() {
    return {
      data: {},
      order_no: '',
      // runSection: null,
      contractTypes,
      // distanceFinal: null,
      Messages,
      movement: '',
    };
  },

  props: ['selected', 'orderDetails', 'disableFreightProvisionRetry'],

  async created() {
    this.order_no = this.$route.params.orderId;
    this.movement = this.orderDetails && this.orderDetails.movement;
    let result;
    const configCheck = (this.configurations && this.configurations.pay_v1_v2) ?
      (this.movement === Movement.SECONDARY) : true;
    const migrationDate = this.configurations.payV1ToV2MigrationDate;
    if (configCheck && this.$hasFeature('payments_v2') && !migrationDate) {
      result = await this.$store.dispatch('freight/getFreightChargeV2', {
        orderId: this.$route.params.orderId,
      });
    } else if (this.$hasFeature('payments_v2_migrated') && this.orderDetails
    && this.orderDetails.delivered_at
    && migrationDate && moment(this.orderDetails.delivered_at) < moment(migrationDate)) {
      result = await this.$store.dispatch('freight/getFreightChargeV1', {
        orderId: this.$route.params.orderId,
      });
    } else {
      result = await this.$store.dispatch('freight/getFreightChargeV2', {
        orderId: this.$route.params.orderId,
      });
    }
    this.data = result;
    this.data.status = this.orderDetails.status;
    this.data.allowRetryFreightProvision = this.orderDetails.allow_retry_freight_provision &&
      this.configurations.payment_settings && this.configurations.payment_settings.retry_freight_provision;
  },
  computed: {
    ...mapGetters({
      configurations: 'app/configurations',
    }),
    contractPrice() {
      const totalContribution = this.data.materials.reduce((total, value) => {
        total += Number(value.contribution) || 0;
        return total;
      }, 0);
      return totalContribution.toFixed(2);
    },
    groupByCenter() {
      return this.data.materials.reduce((res, value) => {
        const result = { ...res };
        if (!result[value.cost_center]) {
          result[value.cost_center] = {
            cost: 0,
            name: value.cost_center,
          };
        }
        result[value.cost_center].cost += Number(value.contribution);
        return result;
      }, {});
    },
  },
};
</script>
<style lang="scss">
$fontSemibold: 'OpenSans-Semibold';
$fontBold: 'OpenSans-Bold';

.app-wrapper {
    background: #fff;
    height: 100vh;
    max-height: 100%;
    border-bottom: 20px solid #f8f8f8;
    padding: 20px;
    .title {
        color: #3A687D;
        font-family:$fontSemibold;
        font-size: 1.6rem;
        letter-spacing: 1px;
        margin: 0;
        text-transform: uppercase;
        padding: 0 0 20px;
        &-border {
            border-bottom: 2px solid #6595CA;
            line-height: 27px;
            width: fit-content;
        }
    }
}
</style>
